import React from "react";

const CardIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5291 21.0122H17.6618V20.8796V20.867V20.2766V20.144H17.5291H5.39002V10.1402C5.39002 8.80047 6.42942 7.72302 7.68156 7.72302H8.89995H9.03262V7.59035V7V6.86733H8.89995H7.68156C5.94539 6.86733 4.53432 8.33851 4.53432 10.1402V20.8796V21.0122H4.66699H17.5291Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.265343"
        stroke-miterlimit="10"
      />
      <path
        d="M21.0643 20.8796V21.0122H21.197C23.097 21.0122 24.6331 19.4024 24.6331 17.4254V7V6.86733H24.5005H13.8364H13.7038V7V7.59035V7.72302H13.8364H23.7774V17.4379C23.7774 18.9411 22.6123 20.1565 21.197 20.1565H21.0643V20.2892V20.8796Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.265343"
        stroke-miterlimit="10"
      />
      <path
        d="M24.3312 12.2773V12.1447H24.1985H5.13135H4.99868V12.2773V12.8677V13.0004H5.13135H24.1985H24.3312V12.8677V12.2773Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.265343"
        stroke-miterlimit="10"
      />
      <path
        d="M24.3312 9.98828V9.85561H24.1985H5.13135H4.99868V9.98828V10.5786V10.7113H5.13135H24.1985H24.3312V10.5786V9.98828Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.265343"
        stroke-miterlimit="10"
      />
      <path
        d="M14.9664 18.235H15.0991V18.1024V15.3516V15.2189H14.9664H6.55078H6.41811V15.3516V18.1024V18.235H6.55078H14.9664ZM14.2309 17.3793H7.27381V16.0871H14.2309V17.3793Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.265343"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default CardIcon;
